module.exports = __webpack_public_path__ + "static/media/img6.5aef0110.svg";